import React, { useEffect, useState } from "react";
import twFocusClass from "utils/twFocusClass";
import axios from "axios";
import "../../../styles/styles.css";

import { Video } from "data/types";
import CardVideo from "./CardVideo";

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});
const totalParPage = 6;

const PageArchiveVideo = () => {
  const [videos, setVideos] = useState<Video[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const categorie = window.location.pathname.replace("/videos/", "");

  useEffect(() => {
    const getVideos = async () => {
      try {
        const response = await axiosInstance.get("api/videos");
        setVideos(response.data);
      } catch (error) {
        console.log("erreur:" + error);
      }
    };
    getVideos();
  }, []);

  const searchVideo = (liste: Video[], cat: string): Video[] => {
    if (cat === "/videos" || cat === "/") return liste;
    return liste.filter(
      (video) => video.categorie.toLowerCase().replace("é", "e") === cat
    );
  };

  const afficherNombreVideo = (liste: Video[], cat: string): number => {
    if (cat === "/videos" || cat === "/") return liste.length;
    return liste.filter(
      (video) => video.categorie.toLowerCase().replace("é", "e") === cat
    ).length;
  };

  const loadData = (page: number, liste: Video[]): Video[] => {
    const start = (page - 1) * totalParPage;
    return liste.slice(start, start + totalParPage);
  };

  const gotoPage = (i: number) => {
    setCurrentPage(i);
  };

  const afficherCategorie = () => {
    if (!categorie.endsWith("videos") && categorie !== "/") {
      return (
        <h3 className="inline-block align-bottom text-1xl font-semibold md:text-3xl ">
          - {categorie}
        </h3>
      );
    }
    return null;
  };

  const getPagesNumbers = () => {
    const totalPages = Math.ceil(
      afficherNombreVideo(videos, categorie) / totalParPage
    );
    const content = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === currentPage) {
        content.push(
          <button
            key={i}
            className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-primary-6000 text-white ${twFocusClass()}`}
          >
            {i}
          </button>
        );
      } else {
        content.push(
          <button
            key={i}
            onClick={() => gotoPage(i)}
            className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-white hover:bg-neutral-100 border border-neutral-200 text-neutral-6000 dark:text-neutral-400 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 ${twFocusClass()}`}
          >
            {i}
          </button>
        );
      }
    }
    return content;
  };

  // Cette variable change à chaque render, pas besoin d'effet supplémentaire
  const filteredVideos = searchVideo(videos, categorie);
  const paginatedVideos = loadData(currentPage, filteredVideos);

  return (
    <div className="stretch  bgColor">
      <div className="container py-6 lg:py-8 ">
        {/* HEADER */}
        <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl ">
          Vidéos&nbsp;
        </h2>
        {afficherCategorie()}
        <span className="block text-neutral-300">
          {afficherNombreVideo(videos, categorie)} vidéos
        </span>

        {/* ====================== END HEADER ====================== */}
        <div className="mt-6 flex flex-col sm:items-center sm:justify-between sm:flex-row">
          <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
          <div className="flex justify-end"></div>
        </div>

        {/* LOOP ITEMS */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 md:gap-x-8 md:gap-y-10 mt-8 lg:mt-10">
          {paginatedVideos.map((video: Video) => (
            <CardVideo key={video.id} video={video} />
          ))}
        </div>

        <br />
        {getPagesNumbers()}
      </div>
    </div>
  );
};

export default PageArchiveVideo;
